import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text, Button } from 'react-native-paper';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

const ErrorMessage = ({ 
  error, 
  onRetry = null, 
  message = 'Bir hata oluştu',
  retryButtonText = 'Tekrar Dene'
}) => {
  // Hata mesajını kontrol et
  const errorMessage = typeof error === 'string' 
    ? error 
    : error?.message || message;

  return (
    <View style={styles.container}>
      <MaterialCommunityIcons
        name="alert-circle"
        size={50}
        color="#e74c3c"
      />
      <Text style={styles.title}>Hata!</Text>
      <Text style={styles.message}>{errorMessage}</Text>
      
      {/* Tekrar deneme butonu (opsiyonel) */}
      {onRetry && (
        <Button 
          mode="contained" 
          onPress={onRetry} 
          style={styles.button}
          icon="reload"
        >
          {retryButtonText}
        </Button>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f9f9f9',
    borderRadius: 10,
    margin: 10,
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginTop: 10,
    marginBottom: 5,
    color: '#e74c3c',
  },
  message: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 15,
    color: '#333',
  },
  button: {
    marginTop: 10,
    backgroundColor: '#3498db',
  },
});

export default ErrorMessage;
